import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import Icon from '../../helpers/Icon'
import * as S from './styled'

const AccordionItem = ({
  itemId,
  className,
  children,
  open,
  setOpen,
  icon,
  label,
  chevronColor,
  onlyMobile
}) => {
  const [expanded, setExpanded] = useState(open)

  useEffect(() => {
    setExpanded(itemId === open)
  }, [open])

  return (
    <S.AccordionItem
      className={`${className} ${expanded ? 'expanded' : ''} ${
        onlyMobile ? 'only-mobile' : ''
      }`}
    >
      <S.AccordionHeading
        className="accordion__heading"
        onClick={() => setOpen(expanded ? false : itemId)}
      >
        {icon && (
          <Icon
            className="accordion__icon"
            name={icon}
            color="blue500"
            size={24}
          />
        )}
        <S.AccordionTitle className="accordion__title">
          {label}
        </S.AccordionTitle>
        <S.AccordionChevron
          className="accordion__chevron"
          color={chevronColor}
          name={`arrow-down-1`}
          size={12}
        />
      </S.AccordionHeading>
      <S.AccordionContent
        initial="collapsed"
        animate={expanded ? 'open' : 'collapsed'}
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 }
        }}
        transition={{ duration: 0.3 }}
        className="accordion__content"
      >
        {children}
      </S.AccordionContent>
    </S.AccordionItem>
  )
}

AccordionItem.defaultProps = {
  chevronColor: 'neutral900',
  open: false,
  setOpen: () => {}
}

AccordionItem.propTypes = {
  itemId: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  chevronColor: PropTypes.string,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  setOpen: PropTypes.func.isRequired,
  onlyMobile: PropTypes.bool
}

export default AccordionItem
